import { sendEmailOfficeHierarchy } from "../../../../actions/Email";
import { useMutation } from "react-query";
//Fetching Carrier Contact

const useSendEmail = () => {
  return useMutation(sendEmailOfficeHierarchy);
};
export default useSendEmail;
